import { Button, Collapse, Stack, Typography } from '@mui/material';
import { m } from 'framer-motion';
import { first } from 'lodash';
import Iconify from 'src/components/iconify';
import { useTranslate } from 'src/locales';
import { Order } from 'src/types';

type MessageDisplayProps = {
  hasPendingRequest?: boolean;
  isDirty: boolean;
  hasAnOrder?: boolean;
  userOrders?: Pick<Order, 'id' | 'orderConfirmationId'>[];
  isDark?: boolean;
  checkoutCompleted?: boolean;
};

const MessageDisplay = ({
  hasPendingRequest,
  isDirty,
  hasAnOrder,
  userOrders,
  isDark,
  checkoutCompleted = false,
}: MessageDisplayProps) => {
  const { t: tEvent } = useTranslate('event');

  return (
    <Stack spacing={1}>
      <m.div
        key="status-message"
        initial={{ height: '0vh' }}
        animate={{
          height: hasPendingRequest || checkoutCompleted ? '4rem' : '0rem',
        }}
        exit={{ height: '0vh' }}
        transition={{ duration: 0.5 }}
      >
        <Collapse in={hasPendingRequest || checkoutCompleted}>
          <Stack
            direction="row"
            alignItems="center"
            gap={1}
            sx={{
              border: '1px solid #FFD369',
              padding: 1,
              borderRadius: 1,
            }}
          >
            <Iconify color="#FFD369" icon="fluent:mail-add-24-regular" height={30} width={30} />
            <Typography variant="subtitle2">
              {checkoutCompleted ? tEvent('holdOn.checkoutCompleted') : tEvent('holdOn.message')}
            </Typography>
            <Iconify icon="line-md:loading-twotone-loop" color="#FFD369" height={35} width={35} />
          </Stack>
        </Collapse>
      </m.div>
      <m.div
        key="ticket-access"
        initial={{ height: '0vh' }}
        animate={{
          height: !isDirty && hasAnOrder ? '4rem' : '0vh',
        }}
        exit={{ height: '0vh' }}
        transition={{ duration: 0.5 }}
      >
        <Collapse in={!isDirty && hasAnOrder}>
          <Stack
            direction="row"
            alignItems="center"
            gap={1}
            sx={{
              border: '1px solid #FFD369',
              padding: 2,
              borderRadius: 1,
            }}
          >
            <Stack flexGrow={1} gap={1.5} direction="row" alignItems="center">
              <Iconify color="#FFD369" icon="solar:ticket-line-duotone" height={30} width={30} />
              <Typography variant="subtitle2">{tEvent('ticketNotification.message')}</Typography>
            </Stack>
            <Button href={`/me/tickets/${first(userOrders)?.id}/`}>
              {tEvent('ticketNotification.accessButton')}
            </Button>
          </Stack>
        </Collapse>
      </m.div>
    </Stack>
  );
};

export default MessageDisplay;
